<template>
    <div class="container">
        <div class="page-wrapper pb-0 text-center d-flex flex-column justify-content-center align-items-center">
            <div class="f60">404</div>
            <div class="f48 my-5" v-dompurify-html="$t('Page does not exist')"/>
            <router-link to="/" class="btn btn-main" v-dompurify-html="$t('Back to main page')"/>
        </div>
    </div>
</template>

<script>
export default {
    name: "Error-404"
}
</script>

<style lang="scss">
//
</style>
